import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

    private baseApUrl = environment.baseApi + '/publico/empresas'

    constructor(private httpClient: HttpClient) { }

    async obtenerDetallesEmpresa(idEmpresa: number):Promise<any>{
        return await this.httpClient.get<any>(`${this.baseApUrl}/detalles/${idEmpresa}`).toPromise();
    }

    async obtenerVacantesCategorias(idEmpresa: number):Promise<any>{
        return await this.httpClient.get<any>(`${this.baseApUrl}/vacantes-categorias/${idEmpresa}`).toPromise();
    }

    async obtenerVacantesPublicadas(idEmpresa: number):Promise<any>{
        return await this.httpClient.get<any>(`${this.baseApUrl}/vacantes-publicadas/${idEmpresa}`).toPromise();
    }

    async obtenerVacantesEstados():Promise<any>{
        return await this.httpClient.get<any>(`${this.baseApUrl}/vacantes-estados`).toPromise();
    }

}
